module.exports = __webpack_public_path__ + "static/media/plan_unselected.876f1e1f.svg";